import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ProposalService } from 'src/app/_services/proposal.service';
import { APIResponse, BasicResponse } from 'src/app/_types/api-responses.types';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { ProposalState } from 'src/app/enums/proposal.enums';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { TaskDetailsService } from '../../../../task-details.service';
import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-send-signed-proposal-action',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, IconsModule, ActionModalComponent],
  templateUrl: './send-signed-proposal.component.html',
})
export class SendSignedProposalComponent extends BaseStepperAction {
  get signedProposal(): ProposalDetails {
    return this.state?.policy;
  }

  get enabled() {
    return (
      this.state?.insuranceFlowData?.status ===
      InsuranceFlowStatus.PENDING_CONTRACT
    );
  }

  proposalSubscription: Subscription;

  submitted = false;

  @ViewChild('actionModal') modal: ActionModalComponent;

  constructor(
    taskDetailsService: TaskDetailsService,
    private readonly proposalService: ProposalService,
    private readonly toastrService: ToastrService
  ) {
    super(taskDetailsService);
  }

  markProposalAsSent() {
    if (this.submitted || !this.signedProposal) return;
    this.submitted = true;
    this.proposalSubscription = this.proposalService
      ._updateProposalState({
        proposalId: this.signedProposal?.proposalId,
        proposalState: ProposalState.SIGNED_DOCS,
      })
      .subscribe({
        next: (res) => {
          if (res.error) this.toastrService.error(res.error.clientErrorMessage);
          this.toastrService.success($localize`Contrat marqué comme envoyé`);
          this.modal.closeModal();
          this.taskDetailsService.refreshTaskDetails();
          this.submitted = false;
        },
        error: (err: APIResponse<BasicResponse>) => {
          this.submitted = false;
          this.toastrService.error(
            err.error?.clientErrorMessage ??
              $localize`Une erreur est survenue lors de la mise à jour de l'offre`
          );
        },
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.proposalSubscription) this.proposalSubscription.unsubscribe();
  }
}
